<template>
    <div>
        <div class="content-header row">
            <div class="content-header-left col-md-6 col-12 mb-2">
                <h3 class="content-header-title mb-0">Products</h3>
                <div class="row breadcrumbs-top">
                    <div class="breadcrumb-wrapper col-12">
                        <ol class="breadcrumb">
                            <li class="breadcrumb-item"><a href="/">Home</a>
                            </li>
                            <li class="breadcrumb-item active">Products
                            </li>
                        </ol>
                    </div>
                </div>
            </div>
        </div>

        <div class="content-body">
            <section class="card">
                <div class="card-header d-flex justify-content-between align-items-center">
                    <h4>Products</h4>
                    <div class="d-flex">
                        <download-excel
                            ref="exporter-csv"
                            v-show="false"
                            type="csv"
                            :data="exportRows"
                            :export-fields="exportFields"
                            :name="'Products_Report.csv'"
                        />
                        <download-excel
                            ref="exporter-xls"
                            v-show="false"
                            :data="exportRows"
                            :export-fields="exportFields"
                            :name="'Products_Report.xls'"
                        />
                        <a href="#" @click.prevent="exportTableData('admin.products.index', {}, 'csv', exportQuery())" class="export-link mr-2">
                            <i class="fas fa-file-csv"></i> Export to CSV
                        </a>
                        <a href="#" @click.prevent="exportTableData('admin.products.index', {}, 'xls', exportQuery())" class="export-link text-warning">
                            <i class="fa fa-file-excel-o"></i> Export to Excel
                        </a>
                    </div>
                </div>

                <div class="card-body">
                    <list-controls
                        :search.sync="search"
                        search-id="product-search"
                        placeholder="Search by product name or description"
                        show-filters
                        @apply="applyFilters"
                        @reset="resetFilters"
                    >
                        <div class="col-md-4">
                            <div class="form-group">
                                <label for="category">By Category</label>
                                <select name="category" id="category" class="form-control form-control-sm"
                                        v-model="filters.category">
                                    <option :value="null">All</option>
                                    <option v-for="category in categories" :key="category.id"
                                            :value="category.id">
                                        {{ category.name }}
                                    </option>
                                </select>
                            </div>
                        </div>
                    </list-controls>
                    <vue-good-table
                        class="dataTable"
                        mode="remote"
                        :isLoading.sync="tableDataLoading"
                        :totalRows="totalRecords"
                        :pagination-options="paginationOptions"
                        :sort-options="sortingOptions"
                        @on-page-change="this.onPageChange"
                        @on-per-page-change="this.onPerPageChange"
                        styleClass="vgt-table"
                        :columns="columns"
                        :rows="allProducts"
                    >

                        <div slot="emptystate" class="loading-container">
                            <img src="/images/Spinner.svg" alt="">
                        </div>
                        <template slot="table-row" slot-scope="props">
                             <span v-if="props.column.field === 'sn'">
                                    {{ serialNo(props) }}
                             </span>
                            <span v-else-if="props.column.field === 'image'">
                               <a :href="props.row.image" target="_blank">
                                   <img :src="props.row.image" :alt="props.row.name +' Image'"
                                        class="img-thumbnail img-fluid"
                                        style="height: auto; max-width:130px; vertical-align: middle; width: 100%;">
                               </a>
                            </span>
                            <span v-else-if="props.column.field === 'is_new'">
                                <template v-if="props.row.is_new">
                                    <span class="badge badge-glow badge-success">Yes</span>
                                </template>
                                <template v-else>
                                    <span class="badge badge-glow badge-danger">No</span>
                                </template>
                            </span>
                            <span v-else-if="props.column.field === 'is_active'">
                                <template v-if="props.row.is_active">
                                    <span class="badge badge-glow badge-success">Active</span>
                                </template>
                                <template v-else>
                                    <span class="badge badge-glow badge-danger">Inactive</span>
                                </template>
                            </span>
                            <table-row-actions v-else-if="props.column.field === 'action'">
                                <Link :href="route('admin.products.edit', props.row.id)" class="dropdown-item">
                                    <i class="feather icon-edit"></i>
                                    Edit
                                </Link>
                                <Link :href="route('admin.products.prices.index', props.row.id)" class="dropdown-item">
                                    <i class="feather icon-edit"></i>
                                    Edit Prices
                                </Link>
                                <a href="#" class="dropdown-item text-danger" @click.prevent="showAlert(props.row.id)">
                                    <i class="feather icon-trash-2"></i>
                                    Delete
                                </a>
                            </table-row-actions>
                        </template>
                    </vue-good-table>
                </div>
            </section>
        </div>
    </div>
</template>

<script>
import Layout from '@/Shared/Layout';
import {Link} from '@inertiajs/vue2'
import ListControls from '@/Shared/ListControls';
import DeleteAlert from "../../Shared/Mixins/DeleteAlert";
import TableExportMixin from "../../Shared/Mixins/TableExportMixin";
import PaginationMixin from "../../Shared/Mixins/PaginationMixin";
import ListQueryMixin from "../../Shared/Mixins/ListQueryMixin";

export default {
    metaInfo: {title: 'Products'},
    props: [
        'products',
        'categories',
    ],
    layout: Layout,
    name: 'ProductIndex',
    components: {
        Link,
        ListControls,
    },
    mixins: [
        DeleteAlert,
        PaginationMixin,
        TableExportMixin,
        ListQueryMixin,
    ],
    data() {
        return {
            filters: {
                category: null
            },
            isLoadingFilter: false,
            allProducts: [],
            exportRows: [],
            totalRecords: 0,
            serverParams: {
                page: 1,
                perPage: 10,
                columnFilters: {},
            },

            paginationOptions: {
                enabled: true,
                mode: 'pages',
                perPage: 10,
                perPageDropdown: [5, 10, 20, 50, 100, 200],
                dropdownAllowAll: false,
            },

            sortingOptions: {
                enabled: false,
            },
            columns: [
                {label: 'S/N', field: 'sn', thClass: 'text-center', tdClass: 'text-center'},
                {label: 'Product Name', field: 'name', thClass: 'text-center', tdClass: 'text-center'},
                {label: 'Category', field: 'category_name', thClass: 'text-center', tdClass: 'text-center'},
                {label: 'Image', field: 'image', thClass: 'text-center', tdClass: 'text-center'},
                {label: 'Description', field: 'description', thClass: 'text-center', tdClass: 'text-center'},
                {label: 'New Product', field: 'is_new', thClass: 'text-center', tdClass: 'text-center'},
                {label: 'Status', field: 'is_active', thClass: 'text-center', tdClass: 'text-center'},
                {
                    label: 'Preparation Time',
                    field: 'preparation_time',
                    thClass: 'text-center',
                    tdClass: 'text-center',
                    formatFn: this.formatFn
                },
                {label: 'Action', field: 'action', sortable: false, thClass: 'text-center', tdClass: 'text-center', width: '70px'},
            ],
            tableDataLoading: false,
        }
    },
    computed: {
        exportFields() {
            return this.buildExportFieldsFromColumns(this.columns);
        },
    },
    mounted() {
        this.allProducts = this.products.data;
        this.totalRecords = this.products.total;
    },

    methods: {
        formatFn: function (value) {
            return value ? `${value} minutes` : '0 minutes';
        },
        paginatedData() {
            return this.loadList('admin.products.index', 'allProducts');
        },
        exportQuery() {
            const params = {};
            const search = (this.search || '').trim();

            if (search) {
                params.search = search;
            }

            if (this.appliedFilters.category) {
                params.category = this.appliedFilters.category;
            }

            return params;
        },
        async deleteProduct(id) {
            this.$inertia.delete(route('admin.products.delete', id), {
                preserveScroll: true,
                onSuccess: () => {
                    this.paginatedData();
                }
            })
        },
        async showAlert(productId) {
            const details = {
                title: "Are you sure you want to delete this product?",
                text: "You won't be able to revert this!",
            }
            await this.deleteAlert(details.title, details.text) ? await this.deleteProduct(productId) : "";
        },
    }
}
</script>
